import { Component, Inject, OnInit } from '@angular/core';

import { AlertService, AuthenticationService, FileBlobService, } from '../../_services/index';

import { LoginHelper } from '../../helpers/index';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DocumentRequest } from "../../_models/documentRequest";
import { DocumentRequestService } from "../../_services/documentRequest.service";
import { saveAs as importedSaveAs } from "file-saver";
import { SelectProjectControlItemComponent } from '../selectProjectControlItem/select-project-control-item.component';
import {ActionItemService} from "../../_services/actionItem.service";
import {ImplementationControlStatementService} from "../../_services/implementationControlStatement.service";

@Component({
    standalone: false,
  selector: 'editdocumentrequest-component',
  templateUrl: 'editImplementationControlStatementSet.component.html',
  styleUrls: ['./editImplementationControlStatementSet.component.scss'],
  providers: [DialogService],
})

export class EditImplementationControlStatementSetComponent implements OnInit {
  implementationControlStatementSet: any;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditImplementationControlStatementSetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authenticationService: AuthenticationService,
    public implementationControlStatementService: ImplementationControlStatementService,
    public alertService: AlertService,
    public formBuilder: FormBuilder,
    public dialogService: DialogService) {
  }

  ngOnInit() {
    this.implementationControlStatementSet = this.data.implementationControlStatementSet || {
      name: ''
    };
    this.form = this.formBuilder.group({
      name: ['', Validators.required]
    });
    this.form.setValue({
      name: this.implementationControlStatementSet.name
    });
  }

  onSave() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return;
    }

    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.alertService.clear();
    this.implementationControlStatementSet.name = this.form.value.name;
    this.implementationControlStatementService.saveImplementationControlStatementsSet({
      id: this.implementationControlStatementSet.id,
      name: this.implementationControlStatementSet.name
    })
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close(this.implementationControlStatementSet);
  }
}
